import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { PulseLoader } from "react-spinners"
import { observer } from "mobx-react-lite"
import { BorderButton, Header, QrScanner, ScreenContainer, StyledButton, Text, Title, XIcon } from "../components"
import { ScanStore } from "../stores/ScanStore"

export const ScanPage = observer(() => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const [store] = useState(() => new ScanStore())

	const handleBarCodeScanned = async (data: string) => {
		if (store.enabled) {
			const success = await store.scan(data)

			if (success) {
				navigate("/success", {
					state: success,
				})
			}
		}
	}

	return (
		<ScreenContainer>
			<div className="flex h-full w-full flex-col items-center">
				<Header
					center={<Title>{t("scan.scan_qr")}</Title>}
					right={
						<StyledButton onClick={() => navigate(-1)}>
							<XIcon />
						</StyledButton>
					}
				/>

				{store.isLoading ? (
					<div className="mt-[50px] flex h-[50%] flex-col items-center justify-center">
						<PulseLoader color="white" size={20} />
					</div>
				) : store.enabled ? (
					<QrScanner onResult={handleBarCodeScanned} />
				) : (
					<div className="mt-[50px] flex h-[50%] flex-col items-center justify-center">
						<Text style="mb-[24px]">{t("scan.invalid_qr_code")}</Text>
						<BorderButton onClick={() => store.enable()} text={t("scan.retry")} />
					</div>
				)}
			</div>
		</ScreenContainer>
	)
})
